import { getAllowedImpersonationOrigins } from "./allowedOrigins";

export type ImpersonationMessage =
  | { type: "impersonation:success" }
  | { type: "impersonation:error"; error: string }
  | { type: "impersonation:sessionExpired" }
  | { type: "impersonation:sessionEnded" };

/**
 * Sends a postMessage to the parent window (admin app) when running in an iframe.
 * Posts to all allowed origins — postMessage with a non-matching targetOrigin
 * silently fails, so only the matching parent will receive the message.
 * No-ops when not in an iframe.
 */
export function postMessageToParent(message: ImpersonationMessage): void {
  if (window.parent === window) {
    return;
  }

  const allowedOrigins = getAllowedImpersonationOrigins();

  for (const origin of allowedOrigins) {
    window.parent.postMessage(message, origin);
  }
}
